import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

type ReadEveryoneSocialSettingsV3 = OpalApi<'ReadEveryoneSocialSettingsV3', 200>

export const readEveryoneSocialSettings: ReadEveryoneSocialSettingsV3 = async ({
  params,
}: Parameters<ReadEveryoneSocialSettingsV3>[0] = {}) => {
  const url = new URL('/v3/everyone_social_settings', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
